import React from 'react';
import './About.css';
import LegalLayout from '../components/legalLayout/LegalLayout';
import soc2Badge from '../assets/soc2-badge.svg';

const About = () => {
  return (
    <LegalLayout>
      <div className="about-content">
        <div className="about-block">
          <section className="about-section">
            <h1>About us</h1>

            <div className="about-video">
              <iframe
                src="https://www.youtube.com/embed/7EEfxDvG6J0"
                title="LifeWink — About Us"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                loading="lazy"
              />
            </div>

            <p className="about-tagline">
              LifeWink carries forth the greatest gift we have in life – to love and to be loved.
            </p>

            <p>
              Life experiences have reinforced something I believe to be true: to love and to be
              loved is life’s greatest gift. LifeWink was created from that belief — reimagining
              how we capture and share our love, today and beyond our lifetime. Guided by love,
              integrity, innovation, and excellence, we put your well-being at the center of
              everything we do. We are deeply committed to your privacy, your safety, and ensuring
              that every LifeWink is authentic and true to you. I wish our world was more loving,
              and that I could be receiving LifeWinks today from those I love and who are no
              longer here. Hoping you choose to capture and share your love through LifeWink, and
              that we leave you in awe, every step of the way.
            </p>
            <p>Kindly,</p>
            <p>Jim Baumann</p>
            <p>Founder, Chief Trust Officer and CEO</p>
          </section>
        </div>

        <hr className="about-divider" />

        <div className="about-block">
          <section className="about-section">
            <h1>Our Promise to Our Members and Recipients</h1>
          <p className="bottom-paragraph">We will earn our Members and Recipients trust.</p>
          <p className="bottom-paragraph">
            We will earn our Members and Recipients trust by being honest and reliable.
          </p>
          <p className="bottom-paragraph">
            We will earn our Members and Recipients trust by being respectful of every person.
          </p>
          <p className="bottom-paragraph">
            We will earn our Members and Recipients trust by being Member and Recipient centric,
            being accessible, and by listening to learn and grow.
          </p>
          <p className="bottom-paragraph">
            We will earn our Members and Recipients trust by never sharing or selling personal
            information.
          </p>
          <p className="bottom-paragraph">
            We will earn our Members and Recipients trust by using security best practices to keep
            all personal data safe.
          </p>
          <p className="bottom-paragraph">
            We will earn our Members and Recipients trust by living our guiding principles of love,
            integrity, innovation, and excellence.
          </p>
          <p className="bottom-paragraph">
            We will earn our Members and Recipients trust by securely saving and storing our
            Members’ timeless private LifeWinks, and precisely and assuredly delivering them to
            their Recipients.
          </p>

          <div className="about-soc2">
            <img src={soc2Badge} alt="SOC 2 Compliance Badge" className="about-soc2-badge" />
            <p className="about-soc2-text">
              LifeWink is SOC-2 Certified — the same independent security standard trusted by the
              world&rsquo;s leading companies, verified by an outside auditor to ensure your data is
              secure, private, and protected.
            </p>
          </div>
          </section>
        </div>
      </div>
    </LegalLayout>
  );
};

export default About;
